module.exports = __webpack_public_path__ + "img/lt.7e3fe92f.svg";